module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4 fw3 flex flex-column items-baseline"
  }, [_c('div', {
    staticClass: "fw3 flex flex-row justify-between items-baseline w-100"
  }, [_c('div', {
    staticClass: "b mb2"
  }, [_c('label', {
    staticClass: "price cera-round-pro f2"
  }, [_vm._v("$" + _vm._s(_vm.pricePerMonth))]), _vm._v(" "), _c('span', {
    staticClass: "cera-round-pro f5 gray-c small-text"
  }, [_vm._v(" / month ")])]), _vm._v(" "), (!_vm.isMonthly) ? _c('div', {
    staticClass: "mt2 silver"
  }, [_c('label', {
    staticClass: "cera-round-pro gray-c fw1 f5 small-text"
  }, [_vm._v("\n        Billed $" + _vm._s(_vm.billedPrice) + " / year\n      ")])]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "cera-round-pro",
    class: _vm.isPhoneOnly ? 'color-gray' : 'color-theme'
  }, [_vm._v("\n    " + _vm._s(_vm.planName) + "\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPhoneOnly),
      expression: "!isPhoneOnly"
    }],
    staticClass: "mt2"
  }, _vm._l((_vm.totalDeductibles), function(item) {
    return _c('div', {
      key: item.message,
      staticClass: "flex flex-row flex-wrap items-baseline lh-copy"
    }, [_c('label', {
      staticClass: "inter f6 mr1"
    }, [_vm._v(_vm._s(item.message))]), _vm._v(" "), (item.smallPrint) ? _c('label', {
      staticClass: "inter gray-c f7 tl"
    }, [_vm._v("\n        for all other electronic devices and more (25 items total)\n      ")]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ff52276","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/summaryBox/SummaryPrice.vue
// module id = 705
// module chunks = 0